import { Prefix } from '@/types'
import { exists } from '@/api'

export interface BibliographySetDetailDetail {
  prefix: Prefix
  bibliographyId: number
  tag: string
  data: string
}

export function BibliographySetDetailDetailFromJSON(
  json: any
): BibliographySetDetailDetail {
  return {
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    tag: exists(json, 'tag') ? json.tag : '',
    data: exists(json, 'data') ? json.data : ''
  }
}
